import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M12.844 10.094a.75.75 0 0 0 1.06 1.06l5.594-5.593v3.688a.75.75 0 0 0 1.5 0V3.75a.75.75 0 0 0-.75-.75H14.75a.75.75 0 1 0 0 1.5h3.689zM9.25 20.998a.75.75 0 0 0 0-1.5H5.56l5.595-5.594a.75.75 0 1 0-1.061-1.06L4.5 18.438v-3.689a.75.75 0 0 0-1.5 0v5.5a.747.747 0 0 0 .75.75z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }